import axios from "axios";
import {baseUrl} from "./constants/Constants.jsx"

const instance = axios.create({
    baseURL: baseUrl
  });
export default instance;